<template>
  <div class="videoWrapper">
    <iframe
      :src="iframesrc"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import store from "./store";
// import { bus } from "../main";

export default {
  //props: ["iframesrc"],
  //   data() {
  //     return {
  //       iframesrc: null
  //     };
  //   },
  created() {
    debugger;
    // bus.$on("iframesrc", data => {
    //   debugger;
    //   this.iframesrc = data;
    // });
  },
  computed: {
    iframesrc() {
      return store.iframesrc;
    }
  }
};
</script>

<style scoped>
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
